import React from "react";
import NumberBoxes from "../NumberBoxes/NumberBoxes";
import {connect} from "react-redux";

function Total(props) {
    return (
        <div id="omzet" className="block">
            <NumberBoxes
                tag1={'orderCountLastHour'} // If you rename this, also rename it in Tag.js
                value1={props.orderCountLastHour}
                label1={"Orders laatste uur"}
                value2={props.orderCountToday}
                label2={"Orders vandaag"}
            />
        </div>
    );
}

const mapStateToProps = (state = {}) => {
    const result = {
        data: null,
    };

    if (typeof state.data === "undefined") {
        return result;
    }

    if (typeof state.data["event-toppy-current-stats"] !== "undefined") {
        state.data["event-toppy-current-stats"].forEach(function (
            current_stat_response
        ) {
            result[current_stat_response.label] = current_stat_response.result;
        });
    }
    if (typeof state.data["event-heuts-current-stats"] !== "undefined") {
        state.data["event-heuts-current-stats"].forEach(function (
            current_stat_response
        ) {
            result[current_stat_response.label] += current_stat_response.result;
        });
    }

    return result;
};

export default connect(mapStateToProps)(Total);
